import { type ComponentProps, memo } from 'react';

export type InitialCommentInputContainer = Pick<ComponentProps<'div'>, 'children'>;

export const InitialCommentInputContainer = memo(({ children }: InitialCommentInputContainer) => {
  return <div className="z-1 w-full ads:bg-base bg-gray-1 py-3">{children}</div>;
});

InitialCommentInputContainer.displayName = 'InitialCommentInputContainer';
